import React from 'react'

export default function DefaultPage() {
  return (
    <div>DefaultPage</div>
  )
}
